export const computeHintElapsedSec = ({
  hintStartFocusSec,
  tilDone,
  elapsedTime,
  focusElapsedSec,
}) => {
  if (typeof hintStartFocusSec !== "number") return 0;
  const base = tilDone ? elapsedTime : focusElapsedSec;
  if (!Number.isFinite(base)) return 0;
  return Math.max(0, base - hintStartFocusSec);
};

export const computeHintCountdowns = (hintUnlockAtSec, hintElapsedSec) => {
  const entries = Object.entries(hintUnlockAtSec || {});
  return entries.reduce((acc, [level, unlockAt]) => {
    const remaining = Math.max(0, Math.round(unlockAt - hintElapsedSec));
    acc[level] = remaining;
    return acc;
  }, {});
};

export const computeEligibleHintLevels = (hintUnlockAtSec, hintElapsedSec) => {
  if (!hintUnlockAtSec || typeof hintElapsedSec !== "number") return [];
  return Object.entries(hintUnlockAtSec)
    .filter(([, unlockAt]) => hintElapsedSec >= unlockAt)
    .map(([level]) => Number(level))
    .filter((level) => Number.isFinite(level))
    .sort((a, b) => a - b);
};

export const hasHintCheckResponse = (responses = [], level) => {
  const target = Number(level);
  if (!Number.isFinite(target)) return false;
  const match = responses.find((entry) => Number(entry?.level) === target);
  if (!match) return false;
  if (match.responseType === "dont_know") return true;
  return String(match.response || "").trim().length > 0;
};

export const canUnlockHintLevel = ({
  level,
  eligibleLevels = [],
  checkResponses = [],
} = {}) => {
  const target = Number(level);
  if (!Number.isFinite(target)) return false;
  if (!eligibleLevels.includes(target)) return false;
  if (target <= 1) return true;
  return hasHintCheckResponse(checkResponses, target - 1);
};
